"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var selectFolder_1 = require("./selectFolder");
var favorites = require("owa-mail-favorites-store");
var owa_mail_folder_forest_store_1 = require("owa-mail-folder-forest-store");
var owa_mail_persona_search_folder_services_1 = require("owa-mail-persona-search-folder-services");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Toggle favorite state of a node
 * @param folder the folder
 */
exports.default = legacy_1.action('toggleFavoriteFolder')(function toggleFavoriteFolder(folder, actionSource) {
    var personaId = owa_mail_persona_search_folder_services_1.getPersonaIdFromExtendedProperty(folder);
    var favoriteId = personaId || folder.FolderId.Id;
    if (favorites.isFolderInFavorites(favoriteId)) {
        // Reset the folder selection to inbox if unfavorite a selected node
        if (favoriteId == owa_mail_folder_forest_store_1.getFolderIdForSelectedNode()) {
            selectFolder_1.default(folderNameToId_1.default('inbox'), 'primaryFolderTree' /* treeType */);
        }
        favorites.lazyRemoveFavoriteFolder.importAndExecute(favoriteId, actionSource);
    }
    else {
        favorites.lazyAddFavoriteFolder.importAndExecute(favoriteId, actionSource);
    }
});
//# sourceMappingURL=toggleFavoriteFolder.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-folder-forest-actions/lib/actions/toggleFavoriteFolder.js
// module id = 4738
// module chunks = 23